import '.cp{max-width:480px;}.ssr-plugin'
import '.er{margin-left:8px;}.ssr-plugin'
import '.es{margin-right:8px;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.ga{height:calc(100% - 128px);}.ssr-plugin'
import '.cq{border-radius:24px;}.ssr-plugin'
import '.ap{position:relative;}.ssr-plugin'
import '.ay{overflow:hidden;}.ssr-plugin'
import '.ag{box-sizing:border-box;}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.gb{border-top-left-radius:24px;}.ssr-plugin'
import '.gc{border-top-right-radius:24px;}.ssr-plugin'
import '.bg{aspect-ratio:1/1;}.ssr-plugin'
import '.ce{top:0px;}.ssr-plugin'
import '.ae{left:0px;}.ssr-plugin'
import '.i{height:100%;}.ssr-plugin'
import '.ex{overflow-y:scroll;}.ssr-plugin'
import '.ey{scrollbar-width:none;}.ssr-plugin'
import '.gd{padding:72px 72px;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.bb{justify-content:center;}.ssr-plugin'
import '.b9{margin-bottom:48px;}.ssr-plugin'
import '.s{max-width:240px;}.ssr-plugin'
import '.d6{object-fit:cover;}.ssr-plugin'
import '.aq{display:block;}.ssr-plugin'
import '.fw{user-select:none;}.ssr-plugin'
import '.fx{-webkit-user-select:none;}.ssr-plugin'
import '.fy{-moz-user-select:none;}.ssr-plugin'
import '.u{border-radius:16px;}.ssr-plugin'
import '.p{flex-direction:column;}.ssr-plugin'
import '.ge{text-align:center !important;}.ssr-plugin'
import '.at{margin-top:8px;}.ssr-plugin'
import '.cr{margin-bottom:24px;}.ssr-plugin'
import '.d3{flex-direction:row;}.ssr-plugin'
import '.q{gap:8px;}.ssr-plugin'
import '.gf{font-size:18px;}.ssr-plugin'
import '.gg{margin-top:2px;}.ssr-plugin'
import '.g5{margin-top:48px;}.ssr-plugin'
import '.gh{max-width:374px;}.ssr-plugin'
import '.e2{direction:ltr;}.ssr-plugin'
import { useRef, useState } from 'react'
import { styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { IconButton } from './IconButton.js'
import { Icon } from '../assets/icons/index.js'
import { VoteButton } from './VoteButton.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { ModalWrapper, MODAL_PANEL_ANIMATION } from './ModalWrapper.js'
import { Flag } from './Flag.js'
import { getVotingRegionName } from '../hooks/useVotingRegion.js'
import { useContentQuery } from '../ctx.js'
import { MOBILE } from '../utils/breakpoints.js'

const SLIDE_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)'
const SLIDE_DURATION = '800ms'

export const ContestantModal = ({
  setModal,
  contestant,
  modalIndex,
  setModalIndex,
  amountOfContestants,
  votes,
  setVotes,
  maxed,
  rtl,
  lang,
}) => {
  const { name, img, song, votingRegion, id } = contestant
  const [direction, setDirection] = useState<'next' | 'prev' | null>(null)
  const [outgoing, setOutgoing] = useState<{
    contestant: typeof contestant
    direction: 'next' | 'prev'
  } | null>(null)

  const { data: lyrics, loading, error } = useContentQuery('lyrics', id, true)
  const lastLyricsRef = useRef<string>('')
  if (lyrics) lastLyricsRef.current = lyrics
  const displayLyrics = lyrics ?? lastLyricsRef.current

  const slideInAnimation =
    direction === 'next'
      ? `step-slide-in-right ${SLIDE_DURATION} ${SLIDE_EASING} both`
      : direction === 'prev'
        ? `step-slide-in-left ${SLIDE_DURATION} ${SLIDE_EASING} both`
        : undefined

  const switchTo = (newIndex: number, dir: 'next' | 'prev') => {
    setOutgoing({ contestant, direction: dir })
    setDirection(dir)
    setModalIndex(newIndex)
  }

  const goPrev = () => {
    switchTo(modalIndex <= 0 ? amountOfContestants - 1 : modalIndex - 1, 'prev')
  }

  const goNext = () => {
    switchTo(modalIndex >= amountOfContestants - 1 ? 0 : modalIndex + 1, 'next')
  }

  return (
    <ModalWrapper
      onDismiss={() => {
        setModal(false)
      }}
    >
      <styled.article className="cp er es a ga cq ap ay ag"
        id="voting-page-contestant-modal"
        style={{
          backgroundColor: transparentColor(colors.primary, 0.9),
          border: `1px solid ${colors.border}`,
          animation: MODAL_PANEL_ANIMATION,
          [MOBILE]: {
            height: 'calc(100% - 16px)',
          },
        }}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <div className="a6 gb gc bg a ce ae"
        />
        <IconButton
          ariaLabel="close-contestant-modal"
          id="voting-page-contestant-modal-action-close-modal"
          variant="ghost"
          size="large"
          icon={<Icon type="closeIcon" />}
          onClick={() => setModal(false)}
          style={{
            position: 'absolute',
            top: 12,
            right: rtl ? 'unset' : 12,
            left: rtl ? 12 : 'unset',
            zIndex: 2,
          }}
        />
        <IconButton
          ariaLabel="previous"
          variant="ghost"
          size="large"
          icon={<Icon type="chevronLeftIcon" />}
          onClick={goPrev}
          style={{
            position: 'absolute',
            top: 167,
            left: 16,
            zIndex: 2,
            transform: rtl ? 'scaleX(-1)' : 'none',
          }}
        />
        <IconButton
          ariaLabel="next"
          variant="ghost"
          size="large"
          icon={<Icon type="chevronRightIcon" />}
          onClick={goNext}
          style={{
            position: 'absolute',
            top: 167,
            right: 16,
            zIndex: 2,
            transform: rtl ? 'scaleX(-1)' : 'none',
          }}
        />

        <div className="i ex ey gd ag ap"
        >
          <div className="o v bb b9 ap"
          >
            <div className="ap s a bg"
            >
              <img className="a i d6 aq bg fw fx fy u"
                key={`img-${modalIndex}`}
                src={img}
                style={{
                  border: `1px solid ${colors.border}`,
                  animation: slideInAnimation,
                }}
              />
            </div>
          </div>
          {/* // content */}
          <div className="ap">
            <styled.div className="o p v ap ge"
              key={`content-${modalIndex}`}
              style={{
                animation: slideInAnimation,
                '& p': {
                  // @ts-ignore
                  textAlign: 'center !important',
                },
              }}
            >
              <h2 style={{ fontFamily: 'Singing-Sans' }}>{name}</h2>
              <div className="at cr o d3 v q"
              >
                <Flag code={votingRegion} />
                <p className="gf gg">
                  {getVotingRegionName(votingRegion, lang.code)}
                </p>
              </div>
              <div>
                <VoteButton
                  id="voting-page-contestant-modal-action-vote-button"
                  votes={votes}
                  votingRegion={votingRegion}
                  setVotes={setVotes}
                  maxed={maxed}
                />
              </div>
              <h3 className="g5 cr"
              >
                {song}
              </h3>

              <div className="gh a e2"
                dangerouslySetInnerHTML={{
                  __html: displayLyrics,
                }}
              />
            </styled.div>
          </div>
        </div>
      </styled.article>
    </ModalWrapper>
  )
}
